<template>
  <modal :show="visible" @close="visible = false" modalClasses="modal-xl">
    <div slot="header">
      <h3>{{ status ? "Thêm báo giá" : "Cập nhật báo giá" }}</h3>
    </div>
    <template>
      <b-tabs>
        <b-tab title="Phiếu báo giá">
          <b-row>
            <b-col cols="3">
              <base-input
                placeholder="Mã tự động nếu để trống"
                v-model="formData.code"
                label="Mã số báo giá"
              ></base-input>
            </b-col>
            <b-col cols="3">
              <base-input
                disabled
                :value="userInfo.name"
                label="Người tạo"
              ></base-input>
            </b-col>
            <b-col cols="3">
              <base-input disabled :value="date" label="Ngày tạo"></base-input>
            </b-col>
            <b-col cols="3">
              <label for>Trạng thái</label>
              <b-badge class="badge-status" variant="primary"
                >Báo giá mới</b-badge
              >
            </b-col>
          </b-row>

          <div class="customer-info">
            <b-row>
              <b-col cols="3">
                <base-input
                  disabled
                  v-model="customer.code"
                  label="Mã số khách hàng"
                ></base-input>
              </b-col>
              <b-col cols="3">
                <base-input
                  disabled
                  v-model="customer.name"
                  label="Tên khách hàng"
                ></base-input>
              </b-col>
              <b-col cols="3">
                <base-input
                  disabled
                  v-model="customer.phone"
                  label="Số điện thoại"
                ></base-input>
              </b-col>
              <b-col cols="3">
                <base-input
                  disabled
                  v-model="customer.email"
                  label="Email"
                ></base-input>
              </b-col>
            </b-row>
          </div>
          <div class="customer-contact-info">
            <b-row>
              <b-col cols="3">
                <base-input
                  disabled
                  v-model="customerContact.name"
                  label="Họ tên người liên hệ"
                ></base-input>
              </b-col>
              <b-col cols="3">
                <base-input
                  disabled
                  v-model="customerContact.phone"
                  label="Số điện thoại người liên hệ"
                ></base-input>
              </b-col>
              <b-col cols="3">
                <base-input
                  disabled
                  v-model="customerContact.mail"
                  label="Email người liên hệ"
                ></base-input>
              </b-col>
              <b-col cols="3">
                <base-input
                  disabled
                  v-model="customerContact.email"
                  label="Email người liên hệ"
                ></base-input>
              </b-col>
            </b-row>
          </div>
          <detail-quota-modal ref="detail-quota-modal" />
        </b-tab>
        <b-tab title="Xem phiếu"></b-tab>
      </b-tabs>
    </template>
    <template #footer>
      <button
        type="button"
        @click="handleClose"
        class="btn btn-secondary"
        data-dismiss="modal"
      >
        Đóng
      </button>
      <button
        type="button"
        @click="status == 'create' ? handleCreate() : handleUpdate()"
        class="btn btn-primary"
      >
        Lưu lại
      </button>
    </template>
  </modal>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import DetailQuotaModal from "@/views/Quoata/components/DetailQuotaModal";
import * as quotaApi from "@/_services/modules/quota.service";
export default {
  computed: {
    ...mapState({
      userInfo: state => state["user"].info
    })
  },
  components: {
    DetailQuotaModal
  },
  data() {
    return {
      visible: false,
      status: "create",
      customer: {},
      customerContact: {},
      formData: {
        code: ""
      },
      date: ""
    };
  },
  watch: {
    visible() {
      this.date = moment().format("DD/MM/YYYY");
    }
  },
  methods: {
    handleClose() {
      this.visible = false;
    },
    chechQuotaDetailData(data) {
      let flag = true;
      data.forEach(element => {
        if (
          !element.productSpecifyId ||
          !element.productId ||
          !element.quantity ||
          !element.price
        ) {
          flag = false;
        }
      });
      return flag;
    },
    async handleCreate() {
      let quotaDetail = this.$refs["detail-quota-modal"].tableData;
      if (!this.chechQuotaDetailData(quotaDetail)) {
        return this.$alertify.error("Vui lòng điền đẩy đủ các trường", {
          duration: 2000
        });
      }
      let data = {
        customerId: this.customer.id,
        quotaDetail,
        quota: this.formData
      };
      await quotaApi.create(data);
      this.$alertify.success("Tạo báo giá thành công", {
        duration: 2000
      });
      this.visible = false;
    },
    handleUpdate() {},
    handleSubmit() {}
  }
};
</script>

<style scoped>
.badge-status {
  height: 48px;
  transform: translateY(-2px);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
